import { createContext, useContext } from 'react';

import type useBreadcrumbs from '~/src/screens/CatalogContent/ContentScreen/hooks/useBreadcrumbs';

export interface RecipeScreenAnalyticsContextType {
  eventSource?: string;
  categoriesBreadcrumbs: ReturnType<typeof useBreadcrumbs>;
  categoryName?: string;
  subcategoryName?: string;
  recipe?: {
    id: string;
    name: string;
    type: string;
  };
}

export const context = createContext<RecipeScreenAnalyticsContextType>({
  categoriesBreadcrumbs: [],
});

export const useRecipeScreenAnalyticsContext = () => {
  const recipeScreenContext = useContext(context);

  return recipeScreenContext;
};
